import React from "react";
import PropTypes from 'prop-types';
import MyInput from '../../components/controls/MyInput';
import _AdminService from "../../modules/AdminService";
import moment from "moment";
import _utils from '../../modules/Utils';
import { Collapse, Tooltip } from "antd";
import ButtonComponent from 'components/controls/Button';
import _notification from 'modules/notification';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import PageHeader from 'components/enterprise/PageHeader';
import StatusBadge from 'components/enterprise/StatusBadge';
import { routesAdmin } from 'routes/Routes';
const { Panel } = Collapse;

class CandidateReview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            posts: [],
            loading: true,
            studentPersonalModel: {},
            challanBankDetailModel: {},
            studentReservationModel: {},
        };
    }

    componentDidMount() {
        this.getStudentPersonalData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.popupData.Application_Id !== this.props.popupData.Application_Id) {
            this.getStudentPersonalData();
        }
    }

    getStudentPersonalData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    //console.log("Application ID: ", this.props.popupData.Application_Id);
                    let response = await _AdminService.GetStudentDataForReview(this.props.popupData.Application_Id);
                    //console.log("Summary Data:  ", response.data);
                    this.setState({
                        data: response.data,
                        studentPersonalModel: response.data.studentPersonalModel,
                        challanBankDetailModel: response.data.challanBankDetailModel,
                        studentReservationModel: response.data.studentReservationModel,
                        otherInformationModel: response.data.otherInformationModel,
                        loading: false
                    });

                } catch (e) {
                    // TODO 
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    onFormStatusUpdate = (value) => {
        //console.log('Student status: ', value);
        if (value < 1) {
            return
        }
        //console.log('Student status 1: ', value);
        const params = {
            ApplicationID: this.props.popupData.Application_Id,
            Is_Approved_Rejected: value,
            Reason_Approved_Rejected: ""
        }

        //console.log("Final data: ", params);

        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.UpdateStudentApprovedRejectedData(params);
                    //console.log("Post response: ", response);
                    if (response.status == 200) {
                        if (this.props.onAdvanceOrClose) {
                            const advanced = this.props.onAdvanceOrClose(this.props.popupData.Application_Id);
                            if (value == 1) {
                                _notification.showMessage('success', advanced ? "Approved. Showing next candidate." : "Form has been approved.");
                            }
                            if (value == 2) {
                                _notification.showMessage('success', advanced ? "Rejected. Showing next candidate." : "Form has been rejected.");
                            }
                            if (value == 3) {
                                _notification.showMessage('success', "Form has been put on hold.");
                            }
                        } else {
                            if (value == 1) {
                                _notification.showMessage('success', "Form has been approved.");
                            }
                            if (value == 2) {
                                _notification.showMessage('success', "Form has been rejected.");
                            }
                            if (value == 3) {
                                _notification.showMessage('success', "Form has been put on hold.");
                            }

                            this.props.onCancel();
                            this.props.onStateChange();
                        }
                        this.setState({
                            loading: false,
                        });
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    };

    render() {
        if (this.state.loading)
            return <LoadingSpinner />

        return (
            <div className="admin-home">
                <div className="container-fluid">
                    <PageHeader
                        title="Candidate Review"
                        breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Candidates', path: routesAdmin.candidateslist.path }, { label: 'Candidate Review' }]}
                    />
                    <div className="row">
                        {!this.state.data.IsRoleNumberGenerated ?
                            <div className="col-12  mb-3 ">
                                <div className=" form-action d-flex justify-content-end">
                                    <ButtonComponent
                                        id="btnSubmit"
                                        type="button"
                                        value="Reject"
                                        onClick={() => this.onFormStatusUpdate(2)}
                                        className="mr-4 button-global button-border  mid  autoHeight " />

                                    <ButtonComponent
                                        id="btnPrint"
                                        type="button"
                                        value="Approve"
                                        onClick={() => this.onFormStatusUpdate(1)}
                                        className="button-global button-primary mid autoHeight " />
                                </div>
                            </div> :
                            <div className="note-wrap col-12 p-3 gl-bxbr my-4" style={{ "marginTop": "15px" }}>
                                <div className=" form-action d-flex justify-content-center">
                                    <label className="font-italic">Roll numbers are generated for the applied post, Approve/Reject actions are not allowed.</label>
                                </div>
                            </div>
                        }
                    </div>
                </div>   
                <div>
                    <div className="ent-panel mb-4 max1200 m-auto cd-information">
                        <div className="admin-inner-wrap p-3">
                            <div className="collapse-container review_Data_Table">
                                <Collapse className="collapse-wrap mb-3" collapsible="header" defaultActiveKey={['1']}>
                                    <Panel header="General Information" key="1">
                                        <table className='table_experience_review'>
                                            <tbody>
                                                <tr>
                                                    <th>Form No.</th>
                                                    <td style={{ color: 'red' }}>{this.state.data.studentPersonalModel.Form_Number}</td>
                                                    <th>Application No.</th>
                                                    <td style={{ color: 'red' }}>{this.state.data.studentPersonalModel.Application_Id}</td>
                                                </tr>
                                                <tr>
                                                    <th>Applied Post</th>
                                                    <td>{this.state.data.studentPersonalModel.Applied_Post}</td>
                                                    <th>Transaction Id :</th>
                                                    <td>{this.state.data.studentPersonalModel.Challan_Transaction_Id}
                                                        </td>
                                                </tr>

                                                <tr>
                                                    <th>Fees</th>
                                                    <td>{this.state.data.studentPersonalModel.Exam_Fee}</td>
                                                    <th>Bank  Transaction Id :</th>
                                                    <td>{this.state.data.studentPersonalModel.Submitted_Challan_Transaction_Id}</td>
                                                </tr>

                                                <tr>
                                                    <th>Form Submit Date</th>
                                                    <td>{moment(this.state.data.studentPersonalModel.Submitted_Date).isValid() ? moment(this.state.data.studentPersonalModel.Submitted_Date).format("DD-MMM-YYYY h:mm:ss a") : 'N/A'}</td>
                                                    <th>Form Status</th>
                                                    <td>
                                                        <StatusBadge
                                                            status={this.state.data.studentPersonalModel.Is_Approved_Rejected == 1 ? "Approved" : this.state.data.studentPersonalModel.Is_Approved_Rejected == 2 ? "Rejected" : "Review Pending"}
                                                            tone={this.state.data.studentPersonalModel.Is_Approved_Rejected == 1 ? "success" : this.state.data.studentPersonalModel.Is_Approved_Rejected == 2 ? "error" : "warning"}
                                                        />
                                                    </td>
                                                </tr>

                                                <tr>
                                                {this.state.data.studentPersonalModel.Roll_Number && <>
                                                    <th>Roll Number :</th>
                                                    <td>{this.state.data.studentPersonalModel.Roll_Number}</td> 
                                                </>}
                                                    <th>Aadhaar</th>
                                                    <td>
                                                        <Tooltip placement="right" title="Click to Download Aadhaar">
                                                            <a className="downloadBtn" download="Aadhaar" href={this.state.data.studentPersonalModel.Aadhar_Image_Path}>Download</a>
                                                        </Tooltip>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </Panel>
                                </Collapse>

                                <Collapse className="collapse-wrap mb-3" collapsible="header" defaultActiveKey={['1']}>
                                    <Panel header="Personal Information" key="1">
                                        <table className='table_100_percent tableHiddenBorder'>
                                            <tbody>
                                                <tr>
                                                    <td className='table_personal_info_review' style={{ padding: 0, borderStyle: 'hidden' }}>
                                                        <table style={{ width: '100%' }}>
                                                            <tbody>
                                                                <tr>
                                                                    <th>Full Name</th>
                                                                    <td>{(this.state.data.studentPersonalModel.First_Name) + ' ' +
                                                                        (this.state.data.studentPersonalModel.Middle_Name) + ' ' +
                                                                        (this.state.data.studentPersonalModel.Last_Name)}
                                                                    </td>
                                                                </tr>
                                                                <tr style={{ height: '25px' }}>
                                                                    <th>Father's Name</th>
                                                                    <td>{this.state.data.studentPersonalModel.Father_Name}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th> Mother's Name</th>
                                                                    <td>{this.state.data.studentPersonalModel.Mother_Name}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th> Contact No.</th>
                                                                    <td><span>Mobile No. : </span>{this.state.data.studentPersonalModel.Mobile_Number} <span> Email : </span>{this.state.data.studentPersonalModel.Email}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Address</th>
                                                                    <td>
                                                                        <div>
                                                                            {this.state.data.studentPersonalModel.Address}
                                                                        </div>
                                                                        <span>Village/City : </span>{this.state.data.studentPersonalModel.Village}, { }
                                                                        <span>Taluka : </span>{this.state.data.studentPersonalModel.Taluka}, { }
                                                                        <span>Dist : </span>{this.state.data.studentPersonalModel.District}, { }
                                                                        <span>Pin Code : </span>{this.state.data.studentPersonalModel.Pin_Code}, { }
                                                                        <span>State : </span>{this.state.data.studentPersonalModel.State} { }
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={2}>
                                                                        <label style={{ marginRight: '20rem', display: 'inline', fontSize: '14px' }}><span>Gender :</span> {this.state.data.studentPersonalModel.Gender}</label>
                                                                        <label style={{ display: 'inline', fontSize: '14px' }}><span>Date Of Birth :</span>{moment(this.state.data.studentPersonalModel.Birth_Date).format('DD-MMM-YYYY')}</label><br></br>
                                                                        <label style={{ display: 'inline', fontSize: '14px' }}><span>Marital Status : </span>{this.state.data.studentPersonalModel.Marital_Status}</label>
                                                                    </td>
                                                                </tr>
                                                                {this.state.data.studentPersonalModel.IsDrivingLicenceMandatory && <tr style={{ height: '25px' }}>
                                                                    <th>Driving Licence No.</th>
                                                                    <td>{this.state.data.studentPersonalModel.DrivingLicenceNumber}</td>
                                                                </tr>}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                    <td style={{ borderStyle: 'hidden' }}>
                                                        <div>
                                                            <div className='textAlignCenter'>
                                                                <img className='receipt_details_profile_img' src={this.state.data.studentPersonalModel.Profile_Pic_Path} alt="Profile" />
                                                            </div>
                                                            <div className='textAlignCenter'>
                                                                <img className='receipt_details_signature_img' src={this.state.data.studentPersonalModel.Signature_Path} alt="Signature" />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Panel>
                                </Collapse>

                                <Collapse className="collapse-wrap mb-3" collapsible="header" defaultActiveKey={['1']}>
                                    <Panel header="Reservation Details" key="1">
                                        <table className='table_reservation_review'>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <label style={{ marginRight: '12rem', display: 'inline', fontSize: '14px' }}><span>Category : </span>{this.state.data.studentReservationModel.Category}</label>
                                                    </td>
                                                    <td>
                                                        <label style={{ marginRight: '12rem', display: 'inline', fontSize: '14px' }}><span>Caste : </span>{this.state.data.studentReservationModel.Caste}</label>
                                                    </td>
                                                    <td colSpan={2}>
                                                        <label style={{ display: 'inline', fontSize: '14px' }}><span> Non Creamy Layer : </span>{(this.state.data.studentReservationModel.Is_NonCreamyLayer_Available) === true ? 'Yes' : 'No'}</label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Physically Handicaped</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Handicaped) === true ? 'Yes' : 'No'}</td>
                                                    <th>Sports</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Player) === true ? 'Yes' : 'No'}</td>
                                                </tr>
                                                <tr>
                                                    <th>Earth Quake Affected</th>
                                                    <td>{(this.state.data.studentReservationModel.Earth_Quake_Affected) === true ? 'Yes' : 'No'}</td>
                                                    <th>Anshkalin</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Anshkalin) === true ? 'Yes' : 'No'}</td>
                                                </tr>
                                                <tr>
                                                    <th>Ex Serviceman</th>
                                                    <td>{(this.state.data.studentReservationModel.Ex_Serviceman) === true ? 'Yes' : 'No'}</td>
                                                    <th>Female</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Ladies) === true ? 'Yes' : 'No'}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Panel>
                                </Collapse>

                                <Collapse className="collapse-wrap mb-3" collapsible="header" defaultActiveKey={['1']}>
                                    <Panel header="Qualification Details" key="1">
                                        <table className='table_qualification_review mt-3'>
                                            <tbody>
                                                <tr>
                                                    <th>Education</th>
                                                    <th>Specialisation</th>
                                                    <th>Name of Board/University</th>
                                                    <th>Year Of Passing</th>
                                                    <th>Marks (%)</th>
                                                    <th>Class</th>
                                                </tr>

                                                {this.state.data.studentQualificationDetailModels.map((item, index) => (

                                                    <tr data-index={index}>
                                                        <th>{item.Qualification}</th>
                                                        <td>{item.Qualification == "Other" ? item.Other_Information : item.Specilisation}</td>
                                                        <td>{item.University_Name}</td>
                                                        <td>{item.Passed_Year}</td>
                                                        <td>{item.Percentage_Grade}</td>
                                                        <td>{item.Class}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </Panel>
                                </Collapse>


                                <Collapse className="collapse-wrap mb-3" collapsible="header" defaultActiveKey={['1']}>
                                    <Panel header="Other Skills & Experience Details" key="1">
                                        <table className='table_experience_review'>
                                            <tbody>
                                                <tr>
                                                    <td colSpan={2}>
                                                        <span>Typing Details</span>
                                                    </td>
                                                    <td colSpan={2}>
                                                        <span>Short Hand Details</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Marathi Typing 30</th>
                                                    <td>{(this.state.otherInformationModel.Is_Marathi_Typing_30) === true ? 'Yes' : 'No'}</td>
                                                    <th>100 Words/minutes</th>
                                                    <td>{(this.state.otherInformationModel.Is_100_WPM) === true ? 'Yes' : 'No'}</td>
                                                </tr>
                                                <tr>
                                                    <th>English Typing 40</th>
                                                    <td>{(this.state.otherInformationModel.Is_English_Typing_40) === true ? 'Yes' : 'No'}</td>
                                                    <th>120 Words/minutes</th>
                                                    <td>{(this.state.otherInformationModel.Is_120_WPM) === true ? 'Yes' : 'No'}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={4}>
                                                        <span>Experience Details</span>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>Organization Name
                                                    </th>
                                                    <th>Designation
                                                    </th>
                                                    <th>From Date
                                                    </th>
                                                    <th>To Date
                                                    </th>
                                                </tr>

                                                {this.state.otherInformationModel && this.state.otherInformationModel.map((item, index) => (<>
                                                    <tr data-index={index}>
                                                        <td>{item.Organisation ? item.Organisation : "N/A"}</td>
                                                        <td>{item.Designation ? item.Designation : "N/A"}</td>
                                                        <td>{item && item.From_Date ? moment(item.From_Date).format('DD-MMM-YYYY') : "N/A"}</td>
                                                        <td>{item && item.To_Date ? moment(item.To_Date).format('DD-MMM-YYYY') : "N/A"}</td>
                                                    </tr>
                                                </>
                                                ))}
                                            </tbody>
                                        </table>
                                    </Panel>
                                </Collapse>
                            </div>
                        </div>
                    </div>
                </div> 

                <div className="container-fluid ">                                     
                    <div className="row">
                        {!this.state.data.IsRoleNumberGenerated ?
                            <div className="col-12 mt-3" >
                                <div className=" form-action d-flex justify-content-end">
                                    <ButtonComponent
                                        id="btnSubmit"
                                        type="button"
                                        value="Reject"
                                        onClick={() => this.onFormStatusUpdate(2)}
                                        className="mr-4 button-global button-border  mid  autoHeight " />

                                    <ButtonComponent
                                        id="btnPrint"
                                        type="button"
                                        value="Approve"
                                        onClick={() => this.onFormStatusUpdate(1)}
                                        className="button-global button-primary mid autoHeight " />
                                </div>
                            </div> :
                            <div className="note-wrap col-12 p-3 gl-bxbr my-4" style={{ "marginTop": "15px" }}>
                                <div className=" form-action d-flex justify-content-center">
                                    <label className="font-italic">Roll numbers are generated for the applied post, Approve/Reject actions are not allowed.</label>
                                </div>
                            </div>
                        }
                    </div>
                </div>    
            </div>
        );
    }
}

export default CandidateReview;

// 0 - Not Submitted                (Student is filling his form)
// 1 - Approved                     (Reviewed by reviewer and approved)
// 2 - Rejected                     (Form rejected and Provided reason for rejection
